import * as Yup from 'yup';
import { CHARS_AFTER_DECIMAL_POINT, CHARS_BEFORE_DECIMAL_POINT } from '../../../../constants';
import { testDecimalFieldFormat } from '../../../../helpers/helpers';

export const nameValidationSchema = Yup.object({
  name: Yup.string()
    .trim()
    .max(40, 'validation.lessThan40Chars')
    .matches(/^[^',<>#]+$/, 'validation.invalidCharactersOnName')
    .matches(/^.*[^\\]$/, 'validation.notEndBackslash')
    .required('validation.fieldRequired'),
});
export const descriptionValidationSchema = Yup.object({
  description: Yup.string()
    .trim()
    .max(128, 'validation.lessThan128Chars')
    .matches(/^[^'\\#]+$|^$/, 'validation.invalidCharactersOnDescription')
    .matches(/^.*[^\\]$|^$/, 'validation.notEndBackslash')
    .matches(/^.*[^/]$|^$/, 'validation.notEndWithSlash')
    .nullable(),
});
export const priceValidationSchema = Yup.object({
  price: Yup.number()
    .test('valid format', 'validation.invalidPriceFormat', (value) =>
      testDecimalFieldFormat(
        value.toString(),
        CHARS_BEFORE_DECIMAL_POINT,
        CHARS_AFTER_DECIMAL_POINT
      )
    )
    .transform((value) => (Number.isNaN(value) ? undefined : value))
    .default(0.0)
    .min(0, 'validation.greaterThan0')
    .typeError('validation.notANumber'),
});
